export const SEARCH_PARAM = {
  PAGE_NUMBER: 'page',
  PAGE_SIZE: 'limit',
  QUERY: 'query',
  SORT: 'sort',
  DATE: 'date',
  EMAIL: 'email',
};
export const PAGE_NUMBER_KEY = 'page';
export const PAGE_SIZE_KEY = 'limit';
export const QUERY_KEY = 'query';
export const SORT_KEY = 'sort';
export const DATE_KEY = 'date';
export const FILE_KEY = 'formFile';

export const DEFAULT_PAGE_NUMBER = 1;
export const DEFAULT_PAGE_SIZE = 10;

export const SORT_OPTION = {
  AUTHOR: {
    key: 'createdByName',
    label: 'Author name',
  },
  TITLE_DESC: {
    key: 'title',
    label: 'Title A-Z',
  },
  TITLE_ASC: {
    key: '-title',
    label: 'Title Z-A',
  },
  DATE_MODIFIED: {
    key: '-modified',
    label: 'Date modified',
  },
  DATE_CREATED: {
    key: '-created',
    label: 'Date created',
  },
};
export const DEFAULT_SORT = SORT_OPTION.DATE_MODIFIED;

export const SORT_OPTIONS = Object.values(SORT_OPTION);

export const DATE_OPTION = {
  ALL_TIME: {
    key: '',
    label: 'All time',
  },
  THIS_WEEK: {
    key: 0,
    label: 'This week',
  },
};
export const DATE_OPTIONS = Object.values(DATE_OPTION);

export const DEFAULT_DATE_OPTION = DATE_OPTION.ALL_TIME;

export const TEXT_POSITION = {
  BOTTOM_LEFT: {
    key: 'bottom-left',
    label: 'Bottom left',
  },
  BOTTOM_RIGHT: {
    key: 'bottom-right',
    label: 'Bottom right',
  },
};
export const TEXT_POSITIONS = Object.values(TEXT_POSITION);

export const IMAGE_ALIGN = {
  LEFT: {
    key: 'left',
    label: 'Left aligned',
  },
  RIGHT: {
    key: 'right',
    label: 'Right aligned',
  },
};
export const IMAGE_ALIGNS = Object.values(IMAGE_ALIGN);
